<template>
  <keep-alive>
    <div class="d-flex align-center">
      <component
        ref="component"
        :is="component"
        :value="value"
        :label="label"
        :path="path"
        :custom-reload-path="customReloadPath"
        :no-search-by-sort-param="noSearchBySortParam"
        :item-text="itemText"
        :item-value="itemValue"
        :params="mandatoryFilters"
        :get-data="responseData"
        :rules="rules"
        :vid="vid"
        :multiple="multiple"
        :chips="chips"
        :deletable-chips="deletableChips"
        :return-object="returnObject"
        :readonly="readonly"
        :clearable="clearable"
        :restore-initial-values="restoreInitialValues"
        :cache-items="cacheItems"
        :exclude-ids="excludeIds"
        :api-get-response-item-text="apiGetResponseItemText"
        @input="$emit('input', $event)"
      />
      <div class="pt-1">
        <slot name="append-outer-actions" />
      </div>
    </div>
  </keep-alive>
</template>

<script>
// components
import genericPickerProps from '@/components/global_components/pickers/generic_picker/mixins/generic-picker-props';

export default {
  name: 'GenericPickerOnlyInputField',
  mixins: [genericPickerProps],
  computed: {
    component() {
      if (this.isFormElement) {
        return 'w-form-autocomplete-lazy';
      }
      return 'w-autocomplete-lazy';
    },
  },
  methods: {
    reset() {
      this.$refs.component.reset();
    }
  }
};
</script>
